import { render, staticRenderFns } from "./EmpzoneColList.vue?vue&type=template&id=327bdcce&scoped=true&"
import script from "./EmpzoneColList.vue?vue&type=script&lang=js&"
export * from "./EmpzoneColList.vue?vue&type=script&lang=js&"
import style0 from "./EmpzoneColList.vue?vue&type=style&index=0&id=327bdcce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327bdcce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('327bdcce')) {
      api.createRecord('327bdcce', component.options)
    } else {
      api.reload('327bdcce', component.options)
    }
    module.hot.accept("./EmpzoneColList.vue?vue&type=template&id=327bdcce&scoped=true&", function () {
      api.rerender('327bdcce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/empzone/col/EmpzoneColList.vue"
export default component.exports